import { Copy } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useGetDurationsSummary } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/hooks/useGetDurationsSummary';
import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';

export interface MealCreditDurationsSummaryProps {
  mealCredit: IMealCredit;
}

export function MealCreditDurationsSummary({
  mealCredit,
}: MealCreditDurationsSummaryProps): JSX.Element {
  const { durationsSummary } = useGetDurationsSummary(mealCredit);

  return (
    <Copy variant="body" whiteSpace="normal">
      {durationsSummary}
    </Copy>
  );
}
